<template>
  <section :style="{ margin: '0 10px 0 5px' }">
    <ion-row>
      <ion-col class="col-filter" :style="{padding: '5px 0'}">
        <!-- Search --> 
        <ion-searchbar 
          v-model="searchInput.value"
          v-if="!computedSearchAsync"
          placeholder="Buscar"
          label="Digite para pesquisar"
          class="searchbar-datatable"
          :style="{height: '40px', margin: '5px 0 0'}"
          @ionClear="clearSearch"
          @change="inputingSearch">
        </ion-searchbar>
        <template v-else>
          <ion-searchbar 
            v-model="searchInputAsync"
            placeholder="Buscar"
            label="Digite para pesquisar"
            class="searchbar-datatable"
            :style="{height: '40px', margin: '5px 0 0'}"
            @ionClear="searchInputAsync = ''">
          </ion-searchbar>
          <ion-button v-if="searchInput.value !== searchInputAsync" @click="searchInput.value = searchInputAsync" :style="{width: '100%'}">
            <ion-icon :icon="checkmarkCircleOutline"></ion-icon> Buscar
          </ion-button>
        </template>
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Filters -->
      <ion-col :style="{padding: '0'}" class="col-filter" v-show="computedFiltersAsync && computedFiltersAsync.length > 0">
        <ion-button
          size="default"
          shape="round" 
          expand="full"
          fill="solid"
          :color="Object.values(filtersMounted).filter(x => !!x).length > 0 ? 'success' : 'medium'"
          @click="openFilter = true">
          Filtros
        </ion-button>
        <ion-modal :is-open="openFilter">
          <DataTableFilters
            ref="DataTableFilters"
            :filtersProps="computedFiltersAsync"
            :filtersMounted="filtersMounted"
            @cancelFilters="openFilter = false"
            v-on:change="updateAsyncFilter"
          />
        </ion-modal>
      </ion-col>
      <ion-col 
        class="col-filter"
        :style="{padding: '0'}"
        :size="filters.filter(x => !x.asyncSearch).length > 3 ? 6 : ''"
        v-for="filter in computedFilters"
        :key="filter.value"
        >
        <!-- <ion-label v-if="filter.filterType == 'switch'">
        </ion-label> -->
        <ion-button
          v-if="filter.filterType == 'switch'"
          size="default"
          shape="round" 
          expand="full"
          fill="solid"
          :color="filtersModelsData[filter.value] ? (filter.value == 'invalidItem') ? 'danger' : (filter.value == 'warningCells') ? 'warning' : 'success' : 'medium'"
          @click="filtersModelsData[filter.value] = !filtersModelsData[filter.value]"
          :disabled="filter.disabled">
          <!-- <ion-icon v-if="filtersModelsData[filter.value]" :icon="checkmarkCircle" slot="start"></ion-icon>   -->
          {{filter.filterLabel || filter.text}}
        </ion-button>
        <ion-button
          v-else-if="filter.filterType == 'switchAsync'"
          size="default"
          shape="round" 
          expand="full"
          fill="solid"
          :color="filtersModelsData[filter.value] ? (filter.value == 'invalidItem') ? 'danger' : (filter.value == 'warningCells') ? 'warning' : 'success' : 'medium'"
          @click="filtersModelsData[filter.value] = !filtersModelsData[filter.value];switchAsync({value: filtersModelsData[filter.value], filter})"
          :disabled="filter.disabled">
          <!-- <ion-icon v-if="filtersModelsData[filter.value]" :icon="checkmarkCircle" slot="start"></ion-icon>   -->
          {{filter.filterLabel || filter.text}}
        </ion-button>
        <ion-button
          v-else 
          expand="full"
          fill="solid"
          @click="showAlert({ filter })" 
          :color="filtersModelsData[filter.value] && filtersModelsData[filter.value].length > 0 ? 'primary' : 'medium'"
          size="default"
          shape="round">
          {{ filter.filterLabel || filter.text }}
          <ion-badge slot="end" :style="{marginRight: '2px'}" v-if="filtersModelsData[filter.value] && filtersModelsData[filter.value].length > 0">
            {{ filtersModelsData[filter.value].length }}
          </ion-badge>
        </ion-button>
      </ion-col>
    </ion-row>

    <!-- Limpar Filtros -->
    <ion-row v-if="filters && filters.filter(f => !f.hide).length > 0" class="ion-no-padding ion-no-margin">
      <ion-col size="12" class="col-filter ion-no-padding ion-no-margin">
        <ion-button  
          fill="clear"
          expand="full"
          color="warning"
          shape="round"
          :style="{margin: '0 0 5px'}"
          @click="clearFilters" size="default"
          >
          <ion-icon :icon="closeOutline"></ion-icon>
          Limpar Todos os Filtros
        </ion-button>
      </ion-col>
    </ion-row>
  </section>
</template>

<script>
  import { createNamespacedHelpers, mapState } from 'vuex'
  import store from "../store";
  import DataTableFilters from "./DataTableFilters.vue"
  import { 
    closeOutline,
    checkmarkCircleOutline,
    checkmarkCircle } from "ionicons/icons";
  import {
    alertController,
    isPlatform,
    // IonLabel,
    IonRow,
    IonModal,
    IonBadge,
    IonButton,
    IonCol,
    IonSearchbar,
    IonIcon,
    // IonToggle
  } from '@ionic/vue'
  export default {
    emits: ['searching', 'filtersAsyncChange', 'filtersChange', 'clearFilters', 'clearSearch'],
    props: ['filters', 'filtersModels', 'search', 'searchAsync'],
    components: {
      // IonLabel,
      IonButton,
      IonRow,
      IonModal,
      IonCol,
      IonBadge,
      // IonChip,
      // IonSelect,
      // IonSelectOption,
      IonSearchbar,
      IonIcon,
      DataTableFilters,
      // IonToggle
    },
    setup() {
      return {
        closeOutline,
        checkmarkCircleOutline,
        checkmarkCircle
      };
    },
    data() {
      return {
        openFilter: false,
        filtersDataTable: [],
        filtersSwitchAsync: [],
        filtersMounted: {},
        filtersAsyncModelsData: {},
        searchInputAsync: '',
        searchInput: {
          value: ''
        },
        filtersModelsData: {}
      }
    },
    computed: {
      ...mapState(['companySelected']),
      isDark() { return store.$isDark },
      computedFiltersAsync() {
        const filters = this.filters
        .filter(x => x.filterType == 'async')
        .map(x => {
          x.source = 'customautocomplete'
          x.itemKey = x.itemValue
          x.filterValue = x.value
          x.label = x.text
          return x
        })
        .sort((a,b) => a.filterIndex-b.filterIndex);
        
        return filters
      },
      computedFilters() {
        const filters = this.filters
        .filter(x => x.filterType != 'async')
        return filters
      },
      computedSearchAsync() {
        return this.searchAsync
      }
    },
    created() {
      this.searchInput = this.search
      this.filtersModelsData = this.filtersModels
    },
    watch: {
      filtersModelsData: {
        handler(newValue, oldVal) {
          if (!this.computedSearchAsync) {
            this.$emit('filtersChange', newValue)
          }
        },
        deep: true
      }
    },
    methods: {
      inputingSearch(event) {
        this.$emit('searching', event.target.value)
      },
      switchAsync({value, filter}) {
        let filters = []
        // Marca estoque Decanter
        if (filter.value == 'outOfStock' && this.companySelected.groupCompany == 'decanter') {
          if (value) {
            let stockField = null
            switch (this.companySelected.M0_CODFIL) {
              case '0201':
                stockField = 'B2_SALDO0201'
                break;
              case '0202':
                stockField = 'B2_SALDO0202'
                break;
              case '0203':
                stockField = 'B2_SALDO0203'
                break;
              case '0204':
                stockField = 'B2_SALDO0204'
                break;
              default:
                // M0_CODIGO '01'
                stockField = 'B2_QATU'
                break;
            }
            let stockFieldFil = null
            switch (this.companySelected.M0_CODFIL) {
              case '0102':
                stockFieldFil = 'B2_SLDFPOL'
                break;
              case '0103':
                stockFieldFil = 'B2_SLDSP3'
                break;
              case '0104':
                stockFieldFil = 'B2_SLDBNU'
                break;
              case '0105':
                stockFieldFil = 'B2_SLDSP5'
                break;
              case '0107':
                stockFieldFil = 'B2_SLDRJ7'
                break;
            }
            if (stockField) filters.push({key: stockField, operator: ">", value: "0"}) 
            if (stockFieldFil) filters.push({key: stockFieldFil, operator: ">", value: "0"}) 
          }
        } else {
          filters = [[`${filter.value}:${value}`]]
        }
        this.filtersSwitchAsync = filters
        this.$emit('filtersAsyncChange', {andFilters: this.filtersDataTable, andOrFilters: filters})
      },
      updateAsyncFilter({filters, filtersMounted}) {
        this.filtersMounted = filtersMounted
        this.filtersDataTable = filters
        this.$emit('filtersAsyncChange', {andFilters: filters, andOrFilters: this.filtersSwitchAsync})
        this.openFilter = false
      },
      async showAlert({filter}) {
        let buttons = [
          {
            text: 'Todos',
            icon: 'checkbox-outline',
            cssClass: 'all-none-button',
            handler: () => {

              // check all checkboxes
              alert.inputs = alert.inputs.map((checkbox) => {
                checkbox.checked = true;
                return checkbox;
              });

              return false;
            }
          }, 
          {
            text: 'Nenhum',
            cssClass: 'all-none-button',
            handler: () => {
              // uncheck all checkboxes
              alert.inputs = alert.inputs.map((checkbox) => {
                checkbox.checked = false;
                return checkbox;
              });

              return false;
            }
          }, 
          {
            text: 'OK',
            handler: (data) => {
              // handle the data returned from the alert here
              this.filtersModelsData[filter.value] = data
            }
          }, 
          {
            text: 'Cancelar',
            role: 'cancel',
          }
        ];

        // adjust button order in four button layout for ios
        if (isPlatform('ios')) {
          const okButton = { ...buttons[2] };
          const cancelButton = { ...buttons[3] };
          buttons = [buttons[0], buttons[1], cancelButton, okButton];
        }

        const alert = await alertController.create({
          header: filter.filterLabel || filter.text,
          inputs: filter.filterItems.map(item => ({
            label: item, 
            value: item, 
            type: 'checkbox', checked: this.filtersModelsData[filter.value] && this.filtersModelsData[filter.value].find(f => f === item)
          })),
          cssClass: 'four-button-alert',
          buttons: [...buttons]
        });

        await alert.present();
      },

      clearFilters(payload = {}) {
        const {invalidItem = false, warningCells = false, filterSA7 = false} = payload
        Object.entries(this.filtersModelsData).forEach(([key,val]) => {
          if (typeof val == 'boolean')
            this.filtersModelsData[key] = false
          else if (Array.isArray(val))
            this.filtersModelsData[key].splice(0)
          else
            console.warn('unknown filter type', key, val)
        })
        this.filtersModelsData['invalidItem'] = invalidItem
        this.filtersModelsData['warningCells'] = warningCells
        this.filtersModelsData['filterSA7'] = filterSA7
        this.filtersMounted = {}
        this.searchInput.value = ''
        this.$emit('clearFilters')
      },
      clearSearch() {
        this.$emit('clearSearch')
      }
    }
  }
</script>

<style>
  .four-button-alert.md .alert-button-group-vertical {
    display: block;
  }
  .four-button-alert.md .alert-button-group-vertical * {
    margin: 0;
    font-size: .9em;
  }
  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(1), 
  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(2) {
    float: left;
    color: var(--ion-color-medium);
  }

  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(3), 
  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(4) {
    float: right;
  }

  .four-button-alert.ios .alert-button-group-vertical {
    flex-direction: row !important;
  }
  .four-button-alert.ios .alert-button-group-vertical button:nth-of-type(1) {
    color: var(--ion-color-medium);
  }
  .four-button-alert.ios .alert-button-group-vertical button:nth-of-type(2) {
    color: var(--ion-color-medium);
    border-right: none;
  }
  .col-filter *:not(ion-icon,ion-badge) {
    padding: 0;
    font-size: .7em;
  }
  .ion-page.dense .col-filter *:not(ion-icon,ion-badge,input) {
    font-size: .6em;
  }
  .searchbar-datatable div {
    padding: 0;
    font-size: .6em;
  }
  ion-searchbar .searchbar-input-container .searchbar-input{
  border-radius: 25px !important;
  }

</style>